import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({
    children,
    allowedRoles = [],
    isAbsences = false,
    isInvoices = false,
}) => {
    const { user } = useAuth();

    // If there's no user, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // If allowedRoles is empty or user's role is in allowedRoles, render children
    if (allowedRoles.length === 0 || allowedRoles.includes(user.role)) {
        // If children is a function, pass the user
        if (typeof children === "function") {
            return children({ user });
        }
        return children;
    }

    // If user's role is not allowed, redirect to appropriate page
    switch (user.role) {
        case "admin":
            if (isAbsences && user?.permissions.includes("absences")) {
                return <Navigate to="/profile" replace />;
            } else if (isInvoices && user?.permissions.includes("invoices")) {
                return <Navigate to="/racuni" replace />;
            } else {
                return <Navigate to="/login" replace />;
            }
        case "owner":
        case "manager":
            return <Navigate to="/pregled" replace />;
        default:
            return <Navigate to="/login" replace />;
    }
};

export default ProtectedRoute;
